module.exports = __webpack_public_path__ + "media/site/images/icons/control-icon-81d466fa4ea16839ed664c0044b7ae74.svg";